// based on rc-cascader 0.17.4
import Cascader from './Cascader';
export default Cascader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-cascader/index.js
// module id = null
// module chunks = 